import WeatherFreshnessText from "../public/WeatherFreshnessText";

export default function WeatherReportSourceStatus({ sourceStatus }) {
  if (!sourceStatus) {
    return null;
  }

  return (
    <section className="panel-card weather-report-sources">
      <p className="eyebrow">Source status</p>
      <WeatherFreshnessText
        healthStatus={sourceStatus.radarFreshnessStatus || "unknown"}
        fallbackActive={sourceStatus.fallbackActive}
      />
      {sourceStatus.satelliteActive ? (
        <p className="muted" role="note">
          Satellite precipitation estimate contributed to this report (not radar).
        </p>
      ) : null}
      {sourceStatus.sourceQuality ? (
        <p className="muted">Overall source quality: {sourceStatus.sourceQuality}</p>
      ) : null}
      {sourceStatus.radarSourceKey ? (
        <p className="muted">Radar source: {sourceStatus.radarSourceKey}</p>
      ) : null}
      {sourceStatus.precipitationSourceKey ? (
        <p className="muted">Precipitation context: {sourceStatus.precipitationSourceKey}</p>
      ) : null}
    </section>
  );
}
